import { useMutation, useQueryClient } from "react-query";
import { updateRoleUsers } from "~/components/Forms/UsersForm/rolesRequest/updateRoleUsers";

export default function useUpdateRole() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ roleData }: { roleData: any }) => {
      const url = `/internal-api/auth/access/user`;
      const method = "PUT";
      return updateRoleUsers(url, method, roleData);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["getRoleUsers"]);
      },
      onError: (error) => {
        console.error("Ошибка мутации:", error);
      },
    }
  );
}
